import React from 'react';

export const Loading = () => {
    return (
      <div className="col-12">
        <i
          className="fa fa-cog fa-spin fa-3x fa-fw"
          style={{ color: "#ff9c71" }}
        ></i>
        <span className="sr-only">Loading...</span>
      </div>
    );
};

